import { useMutation } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';

import { createBrandInfo } from 'services/members';

const useSaveBrandWizardProduct = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (params) => {
      return createBrandInfo({
        brandName: params.brandName,
        id: params.id,
        memberId: params.memberId,
      });
    },
    onError: () => {
      CustomNotification.error('Failed to create brand');
    },
  });

  return { saveBrand: mutateAsync, isLoading };
};

export default useSaveBrandWizardProduct;
